import { Fragment } from 'react';
import { parseAutoLinks } from '@/lib/autoLink';

interface Props {
  text: string;
  className?: string;
}

/**
 * Renders plain text with ``https?://`` URLs converted to clickable
 * anchor tags. Newlines are preserved via ``whitespace-pre-wrap`` on
 * the wrapper. Uses ``rel="noopener noreferrer"`` so opening external
 * links can't reach back into the parent window.
 *
 * React's JSX escapes the text content automatically — ``parseAutoLinks``
 * never builds HTML strings, so there's no XSS attack surface.
 */
export function AutoLinkText({ text, className }: Props) {
  const segments = parseAutoLinks(text);
  return (
    <span className={className}>
      {segments.map((seg, i) =>
        seg.type === 'text' ? (
          <Fragment key={i}>{seg.value}</Fragment>
        ) : (
          <Fragment key={i}>
            <a
              href={seg.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-orange hover:underline break-all"
            >
              {seg.href}
            </a>
            {seg.trailing}
          </Fragment>
        ),
      )}
    </span>
  );
}
